import React,{useEffect,useState,useContext} from 'react';
import ReactTooltip from 'react-tooltip';
import { Form, Table, Container, Row, Col, Modal, Button, Nav } from 'react-bootstrap';
//import { Link } from "react-router-dom";

import { apiUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
//import { HubspotForm } from "Api/HubspotApi.js";

import axios from "axios";

//import { local_routes } from 'utils/Routes';

//import Select from 'react-select';

import UserContext from 'store/UserContext';





//import { assembleNickname, get_current_unix_stamp } from "utils/Helper.js";



import './style.css';

function ZoomControlModal (props) {
  //console.log("OnboardingModal constructor",props);
  
  const user_context = useContext(UserContext);

  const [tab_choice, setTabChoice] = useState('zoom_webinar_object');

  //const [step_name, setStepName] = useState('');
  const [loading, setLoading] = useState(true);
  const [zoom_webinar_id, setZoomWebinarId] = useState(props.entity_info.zoom_webinar_id || '');
  const [zoom_info, setZoomInfo] = useState({});
  
  const [message, setMessage] = useState(false);

  const tab_info = {
    zoom_webinar_object: {
      title: "Webinar Information",
    },
    zoom_panelists_array: {
      title: "Panelists",
    },
    zoom_registrants_array: {
      title: "Registrants",
    }
  };

  async function refreshZoomInfo () {
    console.log("refreshZoomInfo");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    await axios.post(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/refreshZoomInfo`,{});
    setupEntities();
  }
  
  async function syncZoomInfo () {
    console.log("syncZoomInfo");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    await axios.post(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/syncZoomInfo`,{});
    //setupEntities();
  }
  
  function onChangeZoomWebinarId (event) {
    setZoomWebinarId(event.target.value);
  }
  
  async function removeZoom () {
    console.log("removeZoom");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    let patch_obj = {
      zoom_webinar_id: '',
      zoom_webinar_object: {},
      zoom_panelists_array: [],
      zoom_registrants_array: [],
      zoom_webinar_zoom_user_email: '',
      zoom_webinar_zoom_user_id: '',
      zoom_webinar_zoom_user_password: ''
    }
    await axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
    setZoomWebinarId('');
    props.onWebinarIdChange('');
    setMessage(false);
    setLoading(false);
  }
  
  async function createZoomWebinar () {
    console.log("createZoomWebinar");
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    let post_obj = {
      topic: props.entity_info.entity_name,
      agenda: props.entity_info['description'].replace(/<[^>]+>/g, ''),
      start_time: props.entity_info.start_time
    }
    let add_zoom_webinar_response = await axios.post(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}/addZoomWebinar`,post_obj);

    // bust cache
    axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.friendly_url}`,myHeaders_Auth_With_Cache_Control);
    
    // put 11-digit zoom_webinar_id into 3-4-4 string
    let tmp_new_zoom_webinar_id = add_zoom_webinar_response.data.zoom_webinar_id;
    //tmp_new_zoom_webinar_id = tmp_new_zoom_webinar_id.slice(0,3)+' '+tmp_new_zoom_webinar_id.slice(3,4)+' '+tmp_new_zoom_webinar_id.slice(7,4);
    
    setZoomWebinarId(tmp_new_zoom_webinar_id);
    props.onWebinarIdChange(add_zoom_webinar_response.data.zoom_webinar_id);
    await refreshZoomInfo();
  }
  
  async function saveZoomWebinarId () {
    console.log("changeZoomWebinarId");
    if (!zoom_webinar_id.match(/^[0-9]{3} [0-9]{4} [0-9]{4}$/)) {
      setMessage(<span style={{ color: 'red', fontSize: 'smaller' }}> Incorrect Zoom Webinar ID format</span>);
      return;
    }
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);
    let patch_obj = {
      zoom_webinar_id,
      zoom_webinar_object: {},
      zoom_panelists_array: [],
      zoom_registrants_array: []
    }
    try {
      await axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
    } catch (err) {
      // probably already used zoom webinar id
      setMessage(<span style={{ color: 'red', fontSize: 'smaller' }}> ERROR: Zoom Webinar ID already in use by another event</span>);  
      return;      
    }
    props.onWebinarIdChange(zoom_webinar_id);
    await syncZoomInfo();
    await refreshZoomInfo();
    
    // bust cache
    axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.friendly_url}`,myHeaders_Auth_With_Cache_Control);
  }

  async function setupEntities (tmp_tab_choice = tab_choice) {
    setLoading(true);
    setMessage(<span style={{ color: 'darkgray', fontSize: 'smaller' }}> Working...</span>);

    let params = {
      attributes: [tmp_tab_choice]
    }

    let zoom_info_response = await axios.get(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control } );

    if (tmp_tab_choice === 'zoom_webinar_object') {
      // display useful things
    }

    console.log("zoom_info_response",zoom_info_response.data);
    setZoomInfo(zoom_info_response.data);

    setMessage(false);
    setLoading(false);
  }

  function changeTab (eventKey) {
    console.log("changeTab",eventKey,tab_choice);
    if (eventKey !== tab_choice) {
      setZoomInfo({});
      setMessage(false);
      setTabChoice(eventKey);
      setupEntities(eventKey);
    }
  }

  useEffect(() => {
    ReactTooltip.rebuild();
  }, [props.entity_info]);

  // on mount
  useEffect(() => {
    console.log("ZoomControlModal useEffect props.show");

    if (!props.entity_info.entity_uuid) {
      return;
    }
    
    if (zoom_webinar_id) {
      setupEntities();
    } else {
      setLoading(false);
    }
    
  }, [props.show]);
  
  function renderZoomInfo() {
    let contents = <React.Fragment></React.Fragment>;
    
    if (tab_choice === 'zoom_webinar_object' && zoom_info.zoom_webinar_object) {
      contents =
        <React.Fragment>
          <Row>
            <Col xs={3}>
              Topic
            </Col>
            <Col style={{ fontSize: "smaller" }}>
              {zoom_info.zoom_webinar_object.topic}
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={3}>
              Start Time
            </Col>
            <Col>
              {new Date(zoom_info.zoom_webinar_object.start_time).toLocaleString()}
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={3}>
              Start URL
            </Col>
            <Col style={{ fontSize: "smaller" }}>
              {zoom_info.zoom_webinar_object.start_url}
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={3}>
              Registration URL
            </Col>
            <Col style={{ fontSize: "smaller" }}>
              {zoom_info.zoom_webinar_object.registration_url}
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={3}>
              Join URL
            </Col>
            <Col style={{ fontSize: "smaller" }}>
              {zoom_info.zoom_webinar_object.join_url}
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col xs={3}>
              Description
            </Col>
            <Col style={{ fontSize: "smaller" }}>
              <pre>{zoom_info.zoom_webinar_object.agenda}</pre>
            </Col>
          </Row>
          <hr/>
          { (zoom_info.zoom_webinar_object.settings && zoom_info.zoom_webinar_object.settings.alternative_hosts) &&
          <Row>
            <Col xs={3}>
              Alternative Hosts
            </Col>
            <Col style={{ fontSize: "smaller" }}>
              <pre>{zoom_info.zoom_webinar_object.settings.alternative_hosts}</pre>
            </Col>
          </Row>
          }          
        </React.Fragment>;
    } else if (tab_choice === 'zoom_panelists_array' && zoom_info.zoom_panelists_array) {
      contents =
        <Table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Join URL</th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "smaller" }} >
            {zoom_info.zoom_panelists_array.map( (element,index) => 
              <tr key={index}>
                <td>{element.name}</td>
                <td>{element.email}</td>
                <td>{element.join_url}</td>
              </tr>
            )}
          </tbody>
        </Table>;
    } else if (tab_choice === 'zoom_registrants_array' && zoom_info.zoom_registrants_array) {
      contents =
        <Table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Join URL</th>
            </tr>
          </thead>
          <tbody style={{ fontSize: "smaller" }} >
            {zoom_info.zoom_registrants_array.map( (element,index) => 
              <tr key={index}>
                <td>{element.last_name ? `${element.first_name} ${element.last_name}` : element.first_name}</td>
                <td>{element.email}</td>
                <td>{element['status']}</td>
                <td>{element.join_url}</td>
              </tr>
            )}
          </tbody>
        </Table>;
    }
    
    return contents;
  }
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Container>
          <Row>
            <Col xs={6}>
              <Modal.Title id="contained-modal-title-vcenter">
                Manage Zoom Integration
              </Modal.Title>
            </Col>
            { props.entity_info.zoom_webinar_id &&
              <React.Fragment>
                <Col xs={6}>

                <Button
                  style={{ marginRight: "5px" }}
                  data-place='bottom'
                  data-tip='Pull raw webinar data from Zoom'
                  disabled={loading}
                  size="sm"
                  variant="pkprimary"
                  onClick={refreshZoomInfo}
                >
                  Refresh Raw Zoom Data
                </Button>
            
                </Col>
              </React.Fragment>
            }
          </Row>
          <Row className="align-items-center" style={{ fontSize: "smaller", marginTop: "5px" }}>
            <Col xs={3}>
              <Form.Group controlId="zoom_webinar_id">
                  <Form.Label style={{ marginBottom: "1px" }}>PK Zoom Webinar ID</Form.Label>
                  <Form.Control
                      // disabled={isTitleChecked}
                      // required
                      //style={{ fontSize: "smaller" }}
                      disabled={loading || props.entity_info.zoom_webinar_id}
                      maxLength="13"
                      pattern="[0-9]{3} [0-9]{4} [0-9]{4}"
                      type="text"
                      value={zoom_webinar_id}
                      onChange={onChangeZoomWebinarId}
                      placeholder="eg. '123 4567 8900'"
                  />
              </Form.Group>
            </Col>
            <Col xs={5}>
              <Button
                disabled={loading}
                size="sm"
                variant="pkprimary"
                onClick={props.entity_info.zoom_webinar_id ? removeZoom : saveZoomWebinarId}
              >
                {props.entity_info.zoom_webinar_id ? 'Remove' : 'Set'}
              </Button>
              {!props.entity_info.zoom_webinar_id &&
                <React.Fragment>
                  <em> - or - </em>
                  <Button
                    disabled={loading}
                    size="sm"
                    variant="pkprimary"
                    onClick={createZoomWebinar}
                  >
                    Create New Webinar
                  </Button>
                </React.Fragment>
              }
            </Col>
            { message &&
              <Col>
                {message}
              </Col>
            }
          </Row>
          { props.entity_info.zoom_webinar_id &&
            <Row className="justify-content-center">
              <h6>Raw Zoom Data</h6>
            </Row>
          }
        </Container>
      </Modal.Header>
      { props.entity_info.zoom_webinar_id &&
        <Modal.Body style={{ overflowX: "visible" }} >
          <Container style={{ height: "400px" }}>
            <Row style={{ paddingBottom: "10px" }}>
              <Col>
                <Nav justify variant="tabs" activeKey={tab_choice} onSelect={(k) => changeTab(k)}>
                  {
                    Object.keys(tab_info).map( tab_name => {
                      return (
                        <Nav.Item key={tab_name}>
                          <Nav.Link eventKey={tab_name}>{tab_info[tab_name].title}</Nav.Link>
                        </Nav.Item>
                      );
                    })
                  }
                </Nav>
              </Col>
            </Row>
            <Row style={{ marginBottom: "20px" }}>
              <Col>
                { !loading &&
                  <React.Fragment>
                    {renderZoomInfo()}
                  </React.Fragment>
                }
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      }
      <ReactTooltip/>
    </Modal>
  );
}

function ZoomControlModalButton (props) {
  const [modalShow, setModalShow] = React.useState(false);

  console.log("ZoomControlModalButton",props);

  let button_icon = <i className="fa fa-plug" aria-hidden="true"></i>;
  let button_text = 'Connect Zoom';
  let button_tooltip = 'Click to Connect to a Zoom Webinar';
  
  if (props.entity_info.zoom_webinar_id) {
    button_text = 'Manage Zoom';
    button_icon = <i className="fa fa-check" aria-hidden="true"></i>;
    button_tooltip = 'Click to Manage your Connected Zoom Webinar'
  } else if (props.disabled === true) {
    button_tooltip = 'Click \'Save + Next\' to Create your Event, and then Connect Zoom';
  }
  //let button_tooltip = 'Click to see more options';

  return (
    <React.Fragment>
      <div data-tip={button_tooltip}>
      <Button
        disabled={props.disabled === true ? true : false}
        
        variant="pkprimary"
        onClick={() => setModalShow(true)}
        size="sm"
      >
        {button_text} {button_icon}
        <ReactTooltip/>
      </Button>
      </div>
    
      <ZoomControlModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        entity_info={props.entity_info}
        onWebinarIdChange={props.onWebinarIdChange}
      />
      
    </React.Fragment>
  );
}

export default ZoomControlModalButton;